export default __webpack_public_path__ + "static/media/modeImg.458c4580.png";